import { getQueryStringsFromUrl } from '@packages/shared';
import type { useRouter } from 'next/router';

export type GetGlycerinOriginProps = ReturnType<typeof useRouter>['asPath'];

export const getGlycerinOrigin = (asPath: GetGlycerinOriginProps) => {
  const { hash, search } = getQueryStringsFromUrl(asPath);

  // add origin if query params or hash contain ref param
  // searches for a "ref" param in search and hash
  const origin = `${search}&${hash}`.split('ref=').at(1)?.split('&').at(0);
  if (origin && origin !== '') {
    return {
      origin,
    };
  }
  return { origin: undefined };
};
